var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelsSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "editor/border_outer_24px 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.88888889,3.55555556 L7.11111111,3.55555556 L7.11111111,5.33333333 L8.88888889,5.33333333 L8.88888889,3.55555556 Z M8.88888889,7.11111111 L7.11111111,7.11111111 L7.11111111,8.88888889 L8.88888889,8.88888889 L8.88888889,7.11111111 Z M12.4444444,7.11111111 L10.6666667,7.11111111 L10.6666667,8.88888889 L12.4444444,8.88888889 L12.4444444,7.11111111 Z M0,1.77777778 L0,14.2222222 C0,15.2 0.8,16 1.77777778,16 L14.2222222,16 C15.2,16 16,15.2 16,14.2222222 L16,1.77777778 C16,0.8 15.2,0 14.2222222,0 L1.77777778,0 C0.8,0 0,0.8 0,1.77777778 Z M14.0952381,15.1111111 L1.9047619,15.1111111 C1.34603175,15.1111111 0.888888889,14.6539683 0.888888889,14.0952381 L0.888888889,1.9047619 C0.888888889,1.34603175 1.34603175,0.888888889 1.9047619,0.888888889 L14.0952381,0.888888889 C14.6539683,0.888888889 15.1111111,1.34603175 15.1111111,1.9047619 L15.1111111,14.0952381 C15.1111111,14.6539683 14.6539683,15.1111111 14.0952381,15.1111111 Z M8.88888889,10.6666667 L7.11111111,10.6666667 L7.11111111,12.4444444 L8.88888889,12.4444444 L8.88888889,10.6666667 Z M5.33333333,7.11111111 L3.55555556,7.11111111 L3.55555556,8.88888889 L5.33333333,8.88888889 L5.33333333,7.11111111 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-new",
    transform: "translate(-31.000000, -406.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "editor/border_outer_24px",
    transform: "translate(31.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/editor/border_outer_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Fill",
    mask: "url(#mask-2)",
    fill: "#418AFE"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.666667, -2.666667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21.3333333,
    height: 21.3333333
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelsSvg);
export default __webpack_public_path__ + "static/media/Models_svg.7905975866dd29797093ca9aaaabddd0.svg";
export { ForwardRef as ReactComponent };